<template>
  <div class="basic_wrap">
    <img src="../images/share/list.png" class="myteam-bg">
    <h1 class="url">22ola.com</h1>
    <div class="recharge-one" v-for="(item, k) in data" v-if="k<100" :key="k">
      <img src="../images/share/t.png" class="tpng" alt="">
      <img src="../images/share/b.png" class="bpng" alt="">
      <div class="order-status">
        <div class="order">
          <img class="game-logo" :src="item.img" alt="">
          <b>{{ item.game_name }}</b>
        </div>
      </div>
      <div class="money3">
        <div class="m-1">
          <div class="mmm">{{ item.bet_amount }}</div>
          <div class="mdec">{{ $t("下注金额") }}</div>
        </div>
        <!-- <div class="m-1">
          <div class="mmm">{{ item.typing_amount }}</div>
          <div class="mdec">{{ $t("打码金额") }}</div>
        </div> -->
        <div class="m-1">
          <div class="mmm">{{ item.win_amount }}</div>
          <div class="mdec">{{ $t("盈利") }}</div>
        </div>
      </div>
      <div class="ct-time">{{ $t("创建时间") }}: {{ item.createtime }}</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { DropdownMenu, DropdownItem } from "vant";

import { Empty } from "vant";

Vue.use(Empty);
Vue.use(DropdownMenu).use(DropdownItem);
import baseHeader from "@/components/baseHeader";

export default {
  name: "moneybag",
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      data: [],

    };
  },
  components: {
    baseHeader,
  },
  created() {
    this.$parent.footer("user");
  },
  mounted() {
    Fetch("/user/betRecord").then((r) => {
      //console.log(r);
      this.data = r.data;
    });
  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
.tpng{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.bpng{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.myteam-bg{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
}

.url {
  text-align: center;
  font-size: 22px;
  color: gold;
  margin-bottom: 20px;
}

.game-logo {
  width: 50px;
}

.showmore {
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}

.ct-time2 {
  padding: 15px 15px;
  font-size: 0.34rem;
  // background:#2b214b ;
  display: flex;
  justify-content: space-between;

}

.ct-time {
  padding: 15px 15px;
  font-size: 0.34rem;
  // background:#2b214b;
  display: flex;
  justify-content: space-between;
  align-items: center;


}

.is_active {
  padding: 15px 15px;
  font-size: 0.34rem;
  line-height: 16px;
  // display: flex;
  justify-content: space-between;
}

.mdec {
  margin-top: 10px;
  width: 100%;
  color: #84A559;
}

.mmm {
  width: 100%;
  font-weight: 700;
  font-size: 0.4rem;
}

.m-1 {
  width: 50%;
  padding: 0;
  text-align: center;
}

.m-1:nth-child(1) {
  border-right: 1px solid rgba(255, 255, 255, 0.446);
}

.m-1:nth-child(2) {
  // border-right: 1px solid rgba(255, 255, 255, 0.446);
}

.money3 {
  width: 95%;
  margin: 0 auto;
  padding: 10px 10px;
  background: #141e0c83;
  display: flex;
  justify-content: space-around;
  color: #90d934;
  border-radius: 5px;
}

.order b {
  margin-left: 10px;
}

.order {
  font-size: 0.35rem;
  display: flex;
  align-items: center;
}

.status {
  // width: 60px;
  padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: linear-gradient(to right, rgb(166, 0, 146), rgb(97, 17, 207));
}

.unpay {
  // width: 60px;
  padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: linear-gradient(to right, rgb(48, 18, 45), rgb(34, 7, 72));
}

.order-status {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 0 8px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.recharge-one {
  width: 95%;
  margin: 15px auto;
  border-radius: 8px;
  color: #84A559;
  overflow: hidden;
  position: relative;
  border: 1px solid #84A559;
}

.basic_wrap {
  background: url("../images/vip/sbg.png");
  margin-top: 0;
  user-select: none;
  min-height: 100vh;
  padding-top: 1rem;
}

/deep/ .base-header {
  background: transparent;
}</style>
